export enum XlWindowState {
    WindowStateMaximize = -4137,
    WindowStateMinimize = -4140,
    WindowStateNormal = -4143,
}
